<form [formGroup]="loginMasterFrom">
  <div class="auth-wrapper">
    <div class="auth-content">
      <div class="card">
        <div class="row align-items-center text-center">
          <div class="col-md-12">
            <div class="card-body">
              <img src="assets/images/auth/auth-logo-dark.png" alt="" class="img-fluid mb-4">
              <h4 class="mb-3 f-w-400">Sign in</h4>
              <div class="form-group mb-3">
                <input type="text" id="email" class="form-control" formControlName="staffMobileNumber"
                  placeholder="Mobile Number"  maxlength="10"   [(ngModel)]="loginMaster.staffMobileNumber">
              </div>
              <div class="form-group mb-4">
                <input type="password" id="password" class="form-control" formControlName="staffPassword"
                  placeholder="Password"[(ngModel)]="loginMaster.staffPassword">
              </div>
              <button class="btn btn-block btn-primary mb-4" (click)="login(loginMaster)">Signin</button>
              <span style="cursor: pointer;" (click)="forgotPassword(loginMaster.staffMobileNumber)">Forgot Password</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>